"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _styledSystem = require("styled-system");

var Background = _styledComponents.default.span.withConfig({
  displayName: "Background",
  componentId: "sc-efoqpu-0"
})(["", " ", " width:1.5rem;height:1.5rem;border-radius:3px;background-color:", ";display:flex;align-items:center;font-size:0.5rem;font-weight:bold;line-height:1.25;color:white;justify-content:center;text-transform:uppercase;"], _styledSystem.color, _styledSystem.layout, function (props) {
  return props.fileType.color;
});

var TextBox = function TextBox(props) {
  return /*#__PURE__*/_react.default.createElement(Background, props, props.fileType.name);
};

var _default = TextBox;
exports.default = _default;